import { ChartColumn } from 'lucide-react';
import { useRecordContext, useTranslate } from 'ra-core';
import { DataTable } from '../../components/admin/data-table';
import { ImageField } from '../../components/admin/image-field';
import { ActionLink } from '../../components/custom/ActionLink';
import { CopyGrowAppLinkButton } from '../../components/custom/CopyGrowAppLinkButton';
import {
  RowActions,
  rowActionClasses,
} from '../../components/custom/RowActions';
import { MoonstarList } from '../Moonstar/MoonstarList';
import { MoonstarListActions } from '../Moonstar/MoonstarListActions';
import { JourneyReportEmailButton } from './JourneyReportEmailButton';

export const JourneysList = () => {
  return (
    <MoonstarList
      sort={undefined}
      actions={
        <MoonstarListActions>
          <JourneyReportEmailButton />
        </MoonstarListActions>
      }
    >
      <DataTable rowClick="edit" bulkActionButtons={false}>
        <DataTable.Col
          source="bannerImageUrl"
          disableSort
          className="w-px whitespace-nowrap"
        >
          <ImageField
            source="bannerImageUrl"
            className="[&_img]:max-h-[50px] [&_img]:max-w-[100px] [&_img]:object-contain"
          />
        </DataTable.Col>
        <DataTable.Col source="name" disableSort />
        <DataTable.Col
          source="description"
          disableSort
          render={(record) => (
            <div className="max-w-[500px] truncate">{record.description}</div>
          )}
        />
        <DataTable.Col
          disableSort
          label="resources.journeys.fields.totalActivities"
          className="w-px whitespace-nowrap"
          cellClassName="text-right"
          headerClassName="text-right"
          render={(record) =>
            (record.sections as { activities: unknown[] }[]).reduce(
              (sum, section) => sum + section.activities.length,
              0
            )
          }
        />
        <DataTable.Col className="w-px whitespace-nowrap">
          <JourneyActions />
        </DataTable.Col>
      </DataTable>
    </MoonstarList>
  );
};

const JourneyActions = () => {
  const record = useRecordContext();
  const translate = useTranslate();

  if (!record) {
    return null;
  }

  return (
    <RowActions orientation="column">
      <ActionLink
        to={`/journeys/${record.id}/analytics`}
        icon={<ChartColumn />}
      >
        {translate('moonstar.analytics.name')}
      </ActionLink>
      <CopyGrowAppLinkButton
        path={`/journeys/${record.id}`}
        className={rowActionClasses}
      />
    </RowActions>
  );
};
